export default __webpack_public_path__ + "static/ios_tab-15c3839a9b324d354eb53a5d22b67ff7.png";